import React from 'react';
import styles from './CoreColumn.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreColumn(props) {
  const { attributes, innerBlocks } = props;
  const width = (attributes.width != '' && attributes.width) ? attributes.width : null;
  const className = attributes.className?.split(' ') || [];
  const styles = formatStyles(attributes.style);

  return (
    <div id={attributes.anchor} className={cx(['ns_column', 'column', ...className, attributes.textColor && `text-color-${attributes.textColor}`, attributes.verticalAlignment && `align-${attributes.verticalAlignment}`])} style={{...styles, flexBasis: width}}>
      {React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] })}
    </div>
  )
}


CoreColumn.fragments = {
  key: `CoreColumnFragment`,
  entry: gql `
  fragment CoreColumnFragment on CoreColumn {
    attributes {
      anchor
      className
      verticalAlignment
      width
      style
      textColor
    }
  }
`,
};

CoreColumn.config = {
	name: 'CoreColumn',
};
CoreColumn.displayName = 'CoreColumn';
